/**
 * Google Search Console API client (AB#297).
 *
 * Backend is env-gated: when Google OAuth isn't configured, `status` reports
 * `configured: false` and `connect` returns `{ configured: false }`.
 */

import { api } from './client';
import type { ApiResponse } from '../types';

export interface SearchStatus {
  configured: boolean;
  connected: boolean;
}

export interface SearchAnalyticsRow {
  page: string;
  clicks: number;
  impressions: number;
  ctr: number;
  position: number;
}

export interface SearchAnalyticsResponse {
  connected: boolean;
  rows: SearchAnalyticsRow[];
  /** GSC property the rows came from (e.g. `sc-domain:example.com`). */
  property?: string;
  /** Set when connected but Google returned no usable data (e.g. `gsc_query_failed`). */
  error?: string;
  detail?: string;
}

/** `connect` returns `{ url }` when configured, else `{ configured: false }`. */
export interface SearchConnectResponse {
  url?: string;
  configured?: boolean;
}

export const searchApi = {
  getStatus: (siteSlug: string) =>
    api.get<ApiResponse<SearchStatus>>(`/v1/sites/${siteSlug}/search/status`),

  connect: (siteSlug: string) =>
    api.get<ApiResponse<SearchConnectResponse>>(`/v1/sites/${siteSlug}/search/connect`),

  getAnalytics: (siteSlug: string) =>
    api.get<ApiResponse<SearchAnalyticsResponse>>(`/v1/sites/${siteSlug}/search/analytics`),

  disconnect: (siteSlug: string) =>
    api.delete<{ disconnected: boolean }>(`/v1/sites/${siteSlug}/search/connection`),
};
